import { useEffect, useState } from 'react'

import { Tooltip } from 'components'

import * as S from './styles'
import { ReactComponent as DefaultSort } from './svg/sort.svg'
import { ReactComponent as AscSort } from './svg/sort-asc.svg'
import { ReactComponent as DescSort } from './svg/sort-desc.svg'

interface SortLabelProps {
  label: string | React.ReactElement
  sortAction?: (sort: string) => void
  controlSort?: string
  disabled?: boolean
}

export const SortLabel: React.FC<SortLabelProps> = ({
  label,
  sortAction,
  controlSort = 'default',
  disabled = false,
}) => {
  const sortValues = ['default', 'ascendent', 'descendent']

  const setControlSort = () => {
    if (sortValues.includes(controlSort)) return controlSort
    return 'default'
  }

  const [sort, setSort] = useState(setControlSort())

  useEffect(() => {
    setSort(setControlSort())
  }, [controlSort])

  const handleSort = () => {
    if (sort === 'default') {
      dispatchSort('ascendent')
    } else if (sort === 'ascendent') {
      dispatchSort('descendent')
    } else {
      dispatchSort('default')
    }
  }

  const dispatchSort = (newSort: string) => {
    setSort(newSort)
    if (sortAction) sortAction(newSort)
  }

  const getSortTooltip = () => {
    return sort === 'default'
      ? 'Ordenar de forma ascendente'
      : sort === 'ascendent'
        ? 'Ordenar de forma descendente'
        : 'Remover ordenação'
  }

  const renderIcon = () => {
    return sort === 'default' ? <DefaultSort /> : sort === 'ascendent' ? <AscSort /> : <DescSort />
  }

  return (
    <Tooltip arrow placement="top" title={getSortTooltip()}>
      <S.Wrapper disabled={disabled} onClick={handleSort}>
        <span>{label}</span>
        {!disabled && renderIcon()}
      </S.Wrapper>
    </Tooltip>
  )
}
